import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import GavelIcon from "@mui/icons-material/Gavel";

const poppins = { fontFamily: "'Poppins', sans-serif" };

export default function TermDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          background: "#fff",
          borderRadius: "20px",
        },
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={3}
        py={2}
        sx={{ borderBottom: "1px solid rgba(15,31,69,0.1)" }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <GavelIcon sx={{ color: "#1e3a6e", fontSize: 20 }} />
          <Typography
            sx={{
              ...poppins,
              fontWeight: 700,
              fontSize: "1rem",
              color: "#0f1f45",
            }}
          >
            Syarat & Ketentuan
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: "rgba(15,31,69,0.5)" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ px: 3, py: 2.5 }}>
        <Box
          component="ol"
          sx={{
            pl: 2.5,
            m: 0,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          {[
            "Setiap pembelian 1 (satu) paket transaksi akan mendapatkan 1 (satu) kupon hadiah yang berkesempatan memenangkan hadiah spesial pada malam acara.",
            "Program ini berlaku untuk seluruh produk polycarbonate dari PT Impack Pratama Industri Tbk.",
            "Periode penyelesaian paket berlaku hingga 31 Agustus 2026.",
            "Extra diskon diberikan langsung pada saat transaksi.",
            "Benefit uang elektronik akan diberikan setelah program berakhir, dengan ketentuan peserta telah menyelesaikan 100% paket yang dipilih serta melalui proses verifikasi oleh tim audit.",
            "Program paket harga spektakuler dapat digabungkan dengan program reguler yang sedang berlangsung.",
            "Skema perhitungan harga adalah sebagai berikut:Pricelist – Diskon Normal – Promo Reguler – Extra Diskon Paket.",
            "Panitia berhak membatalkan paket apabila ditemukan ketidaksesuaian terhadap ketentuan yang berlaku di lapangan.",
          ].map((item, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                ...poppins,
                fontSize: "0.82rem",
                color: "rgba(15,31,69,0.75)",
                lineHeight: 1.7,
                textAlign: "justify",
              }}
            >
              {item}
            </Box>
          ))}
        </Box>
      </DialogContent>

      {/* Footer */}
      <Box px={3} pb={3}>
        <Button
          onClick={onClose}
          variant="contained"
          fullWidth
          sx={{
            ...poppins,
            background: "#1e3a6e",
            color: "#fff",
            borderRadius: "12px",
            py: 1.4,
            fontSize: "0.9rem",
            fontWeight: 700,
            textTransform: "none",
            boxShadow: "0 6px 24px rgba(15,31,69,0.3)",
            "&:hover": { background: "#162d57" },
          }}
        >
          Tutup
        </Button>
      </Box>
    </Dialog>
  );
}
